import Atropos from 'atropos/atropos.js';
// Initialize


if( !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
	document.querySelectorAll('.atropos').forEach((element) => {
		Atropos({
			// pass unique element here
			el: element,
			activeOffset: 50,
			shadowScale:0,
			rotateXMax:5,
			rotateYMax:5,
			highlight:true,
			rotateTouch:false,
			onEnter() {
				// console.log('Enter');
				$(".atropos-active").parent().css("z-index","50000")
			},
			onLeave() {
				// console.log('Leave');
			},
			onRotate(x, y) {
				// console.log('Rotate', x, y);
			}
		});
	})

}


